import { Link } from "~/components/Link";
import { AuthUserEvents } from "~/modules/analytics/events/auth";
import { Routes } from "~/routes";
import { AuthCard, AuthCardHeader } from "../AuthCard";
import { Button } from "~/components/ui/button";

// // // //

export function LoggedInCard(props: {
    email: string;
    variant: "login" | "register";
}) {
    const { email, variant } = props;

    const analyticsLabel =
        variant === "login"
            ? AuthUserEvents.LoginPageContinueWhenSignedIn
            : AuthUserEvents.RegisterPageContinueWhenSignedIn;

    const title = <>You&apos;re signed in</>;

    const description = (
        <>
            Signed in as{" "}
            <span className="font-medium text-foreground">{email}</span>.
            Continue to the app or sign out from the user menu.
        </>
    );

    return (
        <AuthCard>
            <AuthCardHeader title={title} description={description} />
            <Button variant="primary" asChild className="mt-4">
                <Link href={Routes.home} analyticsLabel={analyticsLabel}>
                    Continue to app
                </Link>
            </Button>
        </AuthCard>
    );
}
